import { Cart } from '@/models/cart/cart'
import { CartItem, NewCartItem } from '@/models/cart/cart-item'
import { CartItemRepository } from '../repository/cart-item-repository'
import { DefaultDealWithItemViaCartSpec } from '../specification/deal-with-item-via-cart/default-deal-with-item-via-cart-spec'
import {
  CommandResult,
  CommandResultContainer,
  DealWithItemViaCartSpec,
} from '../specification/deal-with-item-via-cart/index'
import { itemShouldExistInCart } from './assertion'

export class RestoreRemovedItemFromCartService {
  static create(repository: CartItemRepository): RestoreRemovedItemFromCartService {
    return new RestoreRemovedItemFromCartService(
      repository,
      new DefaultDealWithItemViaCartSpec()
    )
  }
  private constructor(
    private readonly repository: CartItemRepository,
    private readonly dealWithItemViaCartSpec: DealWithItemViaCartSpec
  ) { }

  async restore(item: CartItem, cart: Cart): Promise<CommandResult> {
    const command = this.dealWithItemViaCartSpec.apply(async (itemOnRun, cartOnRun) => {
      try {
        itemShouldExistInCart(itemOnRun, cartOnRun)

        /**
         * 親子商品には集約的な制約があるが、カートリソースとしては親子商品が等しく露出している。
         * client側のコードで集約が表現されるまでは、集約のルートとして機能する親商品に対してのみアクションを実行可能とする。
         */
        if (itemOnRun.isChild) {
          throw new Error(`Restore should not be called for child item(${itemOnRun.id})`)
        }

        return this.repository.add(NewCartItem.createFromCartItem(itemOnRun)).then(r => r.fold(
          e => CommandResultContainer.createAsFail([e]),
          () => CommandResultContainer.createAsSuccess({
            ...itemOnRun,
            removed: false,
          })
        ))
      } catch (e) {
        return CommandResultContainer.createAsFail([e])
      }
    })

    return command(item, cart)
  }
}
